import { ReactNode } from "react";
import styles from "./PageTitle.module.css";

const PageTitle = ({ title }: { title: ReactNode }) => (
  <h2 id="page-title" className={styles.pageTitle}>
    {title}
  </h2>
);

export default PageTitle;
